function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 420,
  cy: 389,
  r: 15,
  fill: "#C59353"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 239,
  cy: 238,
  stroke: "#C59353",
  strokeWidth: 2,
  opacity: 0.603,
  rx: 238,
  ry: 237
}));

function SvgGroup31(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 478 477"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NzggNDc3Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04NCAtMTQ3NSkgdHJhbnNsYXRlKDg0IDE0NzYpIj4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjQyMCIgY3k9IjM4OSIgcj0iMTUiIGZpbGw9IiNDNTkzNTMiLz4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGN4PSIyMzkiIGN5PSIyMzgiIHN0cm9rZT0iI0M1OTM1MyIgc3Ryb2tlLXdpZHRoPSIyIiBvcGFjaXR5PSIuNjAzIiByeD0iMjM4IiByeT0iMjM3Ii8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgGroup31 as ReactComponent };